import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import reducers from './reducers/reducers';
import middlewares from './middlewares/middlewares'

export default function configureStore() {
    return createStore(
        reducers,
        applyMiddleware(...middlewares)
    );
}